// @ts-strict-ignore
import {EntryRowTypeHelpers} from 'common/query-builder/query-entry-section/row-types/types';
import {EntryPart, MetricEntry} from 'common/query-builder/query-entry-section/types';
import {ReportName} from 'common/report/constants';

// eslint-disable-next-line import/no-cycle
import {FunnelsMetricEntryRow} from './index';
import {getNewEntry, hasSavedFunnelBehaviors} from './utils';

export const helpers: EntryRowTypeHelpers<MetricEntry> = {
  component: FunnelsMetricEntryRow,
  getNewEntry: (section) => {
    return getNewEntry({
      isExpanded:
        section.props.reportName !== ReportName.Insights ||
        !hasSavedFunnelBehaviors({behaviors: section.props.behaviors}),
    });
  },
  isPlaceholder: ({entry, sectionProps}) => {
    // "stage" metric entry only in Insights report mode. If not insights report mode, there is no "staged" state.
    // Therefore, always return false for non Insights report mode.
    if (sectionProps.reportName !== ReportName.Insights) {
      return false;
    }
    const behaviors = entry.behavior.behaviors || [];
    return behaviors.length < 2 || !behaviors.every((behavior) => !!behavior.name);
  },
  getDefaultActiveEntryPart: ({behaviorsCtx}) => {
    if (!hasSavedFunnelBehaviors({behaviors: behaviorsCtx})) {
      return EntryPart.SubValue;
    }
    return EntryPart.Value;
  },
};
